import i18n from "i18next";
//import LanguageDetector from "i18next-browser-languagedetector";
import XHR from "i18next-xhr-backend";
 import gbEnglishTrans from "./locales/en/translation-GB.json";
//import caEnglishTrans from "./locales/en/translation-CA.json";
//import atGermanTrans from "./locales/de/translation.json";
//import caFrenchTrans from "./locales/fr/translation.json";

export default function (initialLanguage) {
    const storedTranslations = sessionStorage.getItem(initialLanguage);
    const translationList = storedTranslations ? JSON.parse(storedTranslations) : gbEnglishTrans;

    const resources = {
        //'en': {
        //    translations: gbEnglishTrans // This is important as it is the default for i18n
        //},
        //'en-US': {
        //    translations: gbEnglishTrans // This is important as it is the default for i18n
        //}
    };
    resources[`${initialLanguage}`] = { translations: translationList };

     i18n
        .use(XHR)
        //.use(LanguageDetector)
        .init({
            // detection: { lookupLocalStorage: 'locale'},
            lng: initialLanguage || "en-GB", // Very important to use this lng param to load the resources  // Don't use this if the language detector is used
            debug: false,
            //react: {
            //    useSuspense: false //   <---- this will do the magic
            //},
            fallbackLng: "en-GB", // use en if detected lng is not available
            keySeparator: false, // we do not use keys in form messages.welcome
            interpolation: {
                escapeValue: false // react already safes from xss
            },
            resources: resources,
            // have a common namespace used around the full app
            ns: ["translations"],
            defaultNS: "translations"
        });
    return i18n;
}